const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function isUuid(val?: string | null): boolean {
  if (!val || typeof val !== 'string') return false
  return UUID_REGEX.test(val.trim())
}

export function resolveBranchId(explicitBranchId?: string): string | undefined {
  if (explicitBranchId && typeof explicitBranchId === 'string' && explicitBranchId.trim()) {
    return explicitBranchId.trim()
  }

  if (typeof window === 'undefined') return undefined

  const resolved =
    localStorage.getItem('current_branch_id') ||
    localStorage.getItem('active_branch_id') ||
    localStorage.getItem('branch_id') ||
    localStorage.getItem('x_branch_id') ||
    localStorage.getItem('branchId') ||
    localStorage.getItem('activeBranchId') ||
    localStorage.getItem('selected_branch_id') ||
    localStorage.getItem('school-erp-branch-id') ||
    sessionStorage.getItem('branch_id') ||
    undefined

  return resolved || undefined
}
